import React from 'react'

function Physics() {
  return (
    <div>Phy</div>
  )
}

export default Physics